export const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,10}$/;
export const phoneNumberRegExp = /^(\+[1-9]\d{8,14})?$/; // https://www.twilio.com/docs/glossary/what-e164 (modified to require at least 9 digits)

export const isEmail = (value: string): boolean => emailRegExp.test(value);

export const isPhoneNumber = (value: string): boolean => phoneNumberRegExp.test(value);
